import { PayloadAction, createSlice } from "@reduxjs/toolkit";

import { EmailFormValues } from "Components/SendEmailModal/Forms/EmailFormValuesInterface";
import { OfferState } from "./interfaces";

const initialState: OfferState = {
  isLoading: false,
  emailSent: false,
  error: null,
};

const offerSlice = createSlice({
  name: "offerEmail",
  initialState,
  reducers: {
    clearErrors: (state) => {
      state.error = null;
      state.emailSent = false;
    },
    operationFailed: (state, action: PayloadAction<string>) => {
      state.error = action.payload?.toString();
      state.isLoading = false;
    },
    sendOfferEmail: (state, _action: PayloadAction<EmailFormValues>) => {
      state.isLoading = true;
    },
    sendOfferEmailSucceeded: (state) => {
      state.isLoading = false;
      state.emailSent = true;
    },
  },
});

export const {
  clearErrors,
  operationFailed,
  sendOfferEmail,
  sendOfferEmailSucceeded,
} = offerSlice.actions;
export const offer = offerSlice.reducer;
